import styled from '@emotion/styled';
import { Box, FormControl, IconButton, TextField } from '@mui/material';

import { customPalette } from '../../../../styles/theme';

export const ModalContainer = styled(Box)`
  position: fixed;
  top: 20%;
  left: 30%;
  width: 450px;
  max-width: 90%;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: ${customPalette.accent['white']};
  padding: 20px;
  z-index: 3000;
  pointer-events: all;
  transition: transform 0.3s ease-in-out;
  will-change: transform;
  position: fixed;
`;

export const ModalHeader = styled(Box)`
  display: flex;
  padding-bottom: 10px;
  margin-bottom: 20px;
  cursor: move;
  align-items: center;
  justify-content: space-between;

  & h6 {
    font-size: 18px;
    color: #323f4b;
    margin: 0;
  }

  svg:first-of-type {
    color: #757575;
  }
`;

export const ModalContent = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export const CloseButton = styled(IconButton)``;

export const SaveButtonContainer = styled(Box)`
  display: flex;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const Overlay = styled(Box)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  z-index: 999;
  pointer-events: none;
`;

export const CustomTextField = styled(TextField)`
  margin-bottom: 16px;
  width: 100%;
`;

export const FlexBox = styled(Box)`
  display: flex;
  align-items: center;

  svg {
    margin-bottom: 10px;
  }
`;

export const StyledFormControl = styled(FormControl)`
  margin-bottom: 16px;
  width: 100%;
`;

export const PreviousTranslationBox = styled(Box)`
  height: 20px;
  margin-bottom: 25px;
`;

export const CustomSelect = styled.select`
  width: 100%;
  height: 56px;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #bdbdbd;
  background-color: white;
  font-size: 16px;
  color: #bdbdbd;
  margin-bottom: 16px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: #a0a0a0;
    box-shadow: none;
  }

  option {
    background-color: white;
    color: #495057;
    padding: 8px;
  }

  option:hover {
    background-color: #d3d3d3 !important;
    color: #495057;
  }

  option:checked {
    background-color: #e0e0e0;
  }

  option:focus {
    background-color: #d3d3d3;
  }
`;

export const CustomSelectWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;

  select {
    width: 100%;
    height: 56px;
    padding: 10px;
    border-radius: 4px;
    border: 1px solid #bdbdbd;
    font-size: 16px;
    background-color: white;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    padding-right: 40px;
  }

  &:after {
    content: '▼';
    transform: scaleX(1.8);
    position: absolute;
    right: 15px;
    color: #bdbdbd;
    pointer-events: none;
    top: 15px;
  }
`;
